import { render, staticRenderFns } from "./encodings.vue?vue&type=template&id=2b9e3480&scoped=true&"
import script from "./encodings.vue?vue&type=script&lang=js&"
export * from "./encodings.vue?vue&type=script&lang=js&"
import style0 from "./encodings.vue?vue&type=style&index=0&id=2b9e3480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e3480",
  null
  
)

export default component.exports